import { lazy, Suspense, type ReactElement } from 'react';
import type { Id, Timestamp } from '@/model';
import { Spinner } from '@/ui';
import { usePeoplePresence } from './presence';
export interface AddFriendProps {
  initialHandle?: string;
  onClose(): void;
}
const AddFriendForm = lazy(() => import('./connection-forms').then(module => ({
  default: module.AddFriendForm
})));
export function AddFriend(props: AddFriendProps) {
  return <Suspense fallback={<Spinner />}><AddFriendForm {...props} /></Suspense>;
}
export interface AcceptFriendRequestProps {
  requestId: Id;
  onClose(): void;
  onAccepted(result: {
    conversationId: Id | null;
  }): void;
}
const AcceptRequestForm = lazy(() => import('./connection-forms').then(module => ({
  default: module.AcceptRequestForm
})));
export function AcceptFriendRequest(props: AcceptFriendRequestProps): ReactElement | null {
  return <Suspense fallback={<Spinner />}><AcceptRequestForm {...props} /></Suspense>;
}
export interface MyCodeProps {
  onClose(): void;
}
const MyCodeForm = lazy(() => import('./links').then(module => ({
  default: module.MyCodeForm
})));
export function MyCode(props: MyCodeProps): ReactElement | null {
  return <Suspense fallback={<Spinner />}><MyCodeForm {...props} /></Suspense>;
}
export interface PresenceInfo {
  accountId: Id;
  state: 'online' | 'offline' | 'recently' | 'within_week' | 'within_month' | 'long_ago' | 'unknown';
  lastSeenAt: Timestamp | null;
}
export function usePresence(accountIds: readonly Id[]): ReadonlyMap<Id, PresenceInfo> {
  return usePeoplePresence(accountIds);
}
